module.exports = __webpack_public_path__ + "static/media/tsu.8c95e2eb.png";